import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { books } from "./booksData";
import {
    Nav,
    Error,
    Ul,
    Div,
    Title,
    Byline,
    H2,
    BookH2,
    Category,
} from "./elements";

const createId = (text) => {
    return text.toLowerCase().replace(" ", "").split("/")[0];
};

function getCategory(text) {
    return text
        .replace("History", "History/Biography/Memoir")
        .replace("Philosophy", "Philosophy/Ethics");
}

export const Book = (props) => {
    const { slug } = useParams();
    let page = "";

    if (slug in books) {
        page = books[slug];
    }

    useEffect(() => {
        if (page !== "") {
            document.title = `${page.title} | Duane Hilton`;
        }
        window.scrollTo(0, 0);
    }, [page]);

    let content = <Error />;
    if (page !== "") {
        const href = `https://www.amazon.com/s?k=${page.title.replace(
            " ",
            "+"
        )}+by+${page.author.replace(" ", "+")}`;

        const topicText = getCategory(page.topic);
        const topicId = createId(topicText);
        const categoryLink = `/books/#${topicId}`;

        content = (
            <Div>
                <Nav />
                <Title>{page.title}</Title>
                <Byline>by {page.author}</Byline>
                <Category>
                    Category: <Link to={categoryLink}>{topicText}</Link>
                </Category>
                <div>{page.body}</div>
                <p>
                    View this book on <a href={href}>Amazon</a>.
                </p>
            </Div>
        );
    }

    return content;
};

export const Books = () => {
    useEffect(() => {
        document.title = "Books | Duane Hilton";
        // check if document has a hash
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            const element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView();
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, []);

    let topics = [];
    for (let k in books) {
        topics.push(books[k].topic);
    }
    topics = [...new Set(topics.sort())];
    topics = topics.reverse();
    let booksByTopic = [];

    for (let i = 0; i < topics.length; i++) {
        let booksList = Object.keys(books)
            .filter((k) => books[k].topic === topics[i])
            .sort((a, b) => a.localeCompare(b))
            .map((k) => {
                return (
                    <li key={k}>
                        <Link to={"/books/" + k}>{books[k].title}</Link> by{" "}
                        {books[k].author}
                    </li>
                );
            });
        const topicText = getCategory(topics[i]);
        const topicId = createId(topicText);

        booksByTopic.push(
            <div key={topics[i]}>
                <BookH2 id={topicId}>
                    <a
                        href={`#${topicId}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        {topicText}
                    </a>
                </BookH2>
                <Ul>{booksList}</Ul>
            </div>
        );
    }

    return (
        <Div>
            <Nav />
            <H2>Quotes and ideas from my booklist</H2>
            {booksByTopic}
        </Div>
    );
};
